//
// Copyright 2020 DXOS.org
//

import { lazy } from 'react';

export const Devtools = lazy(() => import('./Devtools'));
export const DevtoolsApp = lazy(() => import('./App'));
